import React from 'react';
import KybConfirmation from '../KybConfirmation';
import KycConfirmation from '../KycConfirmation';
import useFieldRevealTracker from '../../hooks/useFieldRevealTracker';
import OwnersConfirmation from '../OwnersConfirmation';

export default function ConfirmationPage({
  kyb,
  setRefreshKyb,
  primaryKyc,
  submittedOnYourBehalf,
  onRevealSuccess,
  onRevealFail,
  token,
  raiseConfig,
  owners,
  allowPhoneNumberUpdate,
}: {
  kyb: Kyb;
  setRefreshKyb: (refresh: symbol) => void;
  primaryKyc: Kyc;
  submittedOnYourBehalf: boolean;
  onRevealSuccess: () => void;
  onRevealFail: () => void;
  token: string;
  raiseConfig?: {
    raiseCampaignId?: string;
    raiseUserId?: string;
  };
  owners: Owner[];
  allowPhoneNumberUpdate?: boolean;
}): React.JSX.Element {
  const fieldsToTrack = ['kyb', 'primaryKyc'];
  const ownersPresent = owners.some((o) => !!o.kyc);
  if (ownersPresent) {
    fieldsToTrack.push('owners');
  }
  const onItemRevealSuccess = useFieldRevealTracker(
    onRevealSuccess,
    fieldsToTrack,
  );
  return (
    <div className='min-h-screen flex justify-center'>
      <div className='w-full'>
        <form>
          <KybConfirmation
            kyb={kyb}
            setRefreshKyb={setRefreshKyb}
            onRevealSuccess={onItemRevealSuccess('kyb')}
            onRevealFail={onRevealFail}
            submittedOnYourBehalf={submittedOnYourBehalf}
            token={token}
            raiseConfig={raiseConfig}
            allowPhoneNumberUpdate={allowPhoneNumberUpdate}
          />
          <hr />
          <KycConfirmation
            kyc={primaryKyc}
            onRevealSuccess={onItemRevealSuccess('primaryKyc')}
            onRevealFail={onRevealFail}
            token={token}
          />
          {ownersPresent && (
            <OwnersConfirmation
              onRevealSuccess={onItemRevealSuccess('owners')}
              onRevealFail={onRevealFail}
              token={token}
              owners={owners}
            />
          )}

          <div className='flex justify-center'>
            <div className='form-state-page-subtitle my-2'>
              If your account representative or owners are incorrect or have
              changed, please reach out to{' '}
              <span className='text-blue-600 form-state-page-subtitle'>
                <a href='mailto:support@snap-raise.com'>
                  support@snapraise.com
                </a>
              </span>{' '}
              or call{' '}
              <span className='text-blue-600 form-state-page-subtitle'>
                <a href='tel:276.531.9260'>(276) 531-9260</a>
              </span>
              .{' '}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
